module.exports = __webpack_public_path__ + "static/media/player_crock.6880a9a4.png";